import { OnInit, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Datastore, DatastoreDocument, } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { LinkColor, LinkHoverColor } from '@freelancer/ui/link';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontType, TextAlign } from '@freelancer/ui/text';
import { requiredTruthy } from '@freelancer/ui/validators';
import { map, startWith, take } from 'rxjs/operators';
var MilestoneReleaseModalComponent = /** @class */ (function () {
    function MilestoneReleaseModalComponent(datastore, modalRef) {
        this.datastore = datastore;
        this.modalRef = modalRef;
        this.HeadingType = HeadingType;
        this.HeadingSize = HeadingSize;
        this.FontColor = FontColor;
        this.FontType = FontType;
        this.Margin = Margin;
        this.ButtonColor = ButtonColor;
        this.ButtonSize = ButtonSize;
        this.LinkHoverColor = LinkHoverColor;
        this.LinkColor = LinkColor;
        this.TextAlign = TextAlign;
        this.checkControl = new FormControl(false, requiredTruthy(''));
    }
    MilestoneReleaseModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.canRelease$ = this.checkControl.statusChanges.pipe(startWith(this.checkControl.status), map(function (status) { return status === 'VALID'; }));
        var milestoneCollection = this.datastore.collection('milestones', function (query) {
            return query
                .where('projectId', '==', _this.milestone.projectId)
                .where('bidId', '==', _this.milestone.bidId)
                .where('bidderId', '==', _this.milestone.bidderId);
        });
        this.paidMilestone$ = milestoneCollection
            .valueChanges()
            .pipe(map(function (milestones) {
            return milestones
                .filter(function (m) { return m.status === 'cleared'; })
                .reduce(function (a, b) { return a + (b.amount || 0); }, 0);
        }));
        var hourlyContractsCollection = this.datastore.collection('hourlyContracts', function (query) {
            return query
                .where('projectId', '==', _this.milestone.projectId)
                .where('bidderId', '==', _this.milestone.bidderId)
                .where('active', '==', true);
        });
        this.isFixedBid$ = hourlyContractsCollection
            .valueChanges()
            .pipe(map(function (hourlyContracts) { return hourlyContracts.length === 0; }));
    };
    MilestoneReleaseModalComponent.prototype.releasePayment = function () {
        var _this = this;
        this.submissionPromise = Promise.all([
            this.milestoneDoc.update(this.milestone),
            this.paidMilestone$.pipe(take(1)).toPromise(),
            this.isFixedBid$.pipe(take(1)).toPromise(),
        ]).then(function (_a) {
            var response = _a[0], paidAmount = _a[1], isFixed = _a[2];
            if (response.status === 'success') {
                // Milestone total amount >= bid amount, COMPLETE redirect to review tab
                if (isFixed &&
                    paidAmount + (_this.milestone.amount || 0) >= _this.bid.amount) {
                    _this.closeModal({ type: 'COMPLETE', bidderId: _this.bid.bidderId });
                    return response;
                }
                _this.closeModal({ type: 'RELEASE' });
                return response;
            }
            return response;
        });
    };
    // undefined for close without releasing
    // 'Complete' for release and project complete
    // 'Release' for just releasing without side effects
    MilestoneReleaseModalComponent.prototype.closeModal = function (param) {
        this.modalRef.close(param);
    };
    return MilestoneReleaseModalComponent;
}());
export { MilestoneReleaseModalComponent };
